import type { TimePermissionOrgConfiguration } from '../types/timePermission';
import { formatMinutes } from './dateTime';

export function emptyTimePermissionOrgConfiguration(): TimePermissionOrgConfiguration {
  return {
    maximumPermissionsPerMonth: 0,
    minimumDurationMinutes: 0,
    maximumDurationMinutes: 0,
    usedMonth: 0,
    remainingMonth: 0,
  };
}

export function isPermissionOrgConfigured(
  configuration: TimePermissionOrgConfiguration | null | undefined,
): configuration is TimePermissionOrgConfiguration {
  return Boolean(
    configuration &&
      configuration.maximumPermissionsPerMonth >= 1 &&
      configuration.minimumDurationMinutes >= 1 &&
      configuration.maximumDurationMinutes >= configuration.minimumDurationMinutes,
  );
}

export function validateTimePermissionApply(input: {
  permissionDateValid: boolean;
  permissionTypeCode: string | null | undefined;
  fromMinutes: number | null;
  toMinutes: number | null;
  reason: string;
  configuration: TimePermissionOrgConfiguration | null;
}): string | null {
  if (!input.permissionDateValid) {
    return 'Permission date must use YYYY-MM-DD format.';
  }
  if (!input.permissionTypeCode?.trim()) {
    return 'Select a permission type.';
  }
  if (input.fromMinutes === null || input.toMinutes === null) {
    return 'From time and to time are required.';
  }
  if (input.toMinutes <= input.fromMinutes) {
    return 'To time must be after from time.';
  }
  if (!isPermissionOrgConfigured(input.configuration)) {
    return 'Permission configuration is not configured.';
  }
  const duration = input.toMinutes - input.fromMinutes;
  if (duration < input.configuration.minimumDurationMinutes) {
    return `Duration must be at least ${formatMinutes(
      input.configuration.minimumDurationMinutes,
    )}.`;
  }
  if (duration > input.configuration.maximumDurationMinutes) {
    return `Duration cannot exceed ${formatMinutes(
      input.configuration.maximumDurationMinutes,
    )}.`;
  }
  if (input.configuration.remainingMonth <= 0) {
    return `Monthly permission quota of ${input.configuration.maximumPermissionsPerMonth} has been used.`;
  }
  if (!input.reason.trim()) {
    return 'Reason is required.';
  }
  return null;
}
